import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import SmoothScroll from "smooth-scroll";

// Smooth Scroll für interne Links aktivieren
new SmoothScroll('a[href*="#"]', {
  speed: 800,
  speedAsDuration: true
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);